import { NgModule } from '@angular/core';
import { ContentLanguageLabelComponent } from './content-language-label.component';

@NgModule({
    declarations: [ContentLanguageLabelComponent],
    exports: [ContentLanguageLabelComponent],
})
export class ContentLanguageLabelModule {}
